/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kind_One_On_Ones_DescInputs */



/**
* | output |
* | --- |
* | "You and one colleague." |
*
* @param {Meetings_Kind_One_On_Ones_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kind_one_on_ones_desc = /** @type {((inputs?: Meetings_Kind_One_On_Ones_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kind_One_On_Ones_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Jij en één collega.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous et un seul collègue.")
	return /** @type {LocalizedString} */ ("You and one colleague.")
});